import {
  HTMLAttributes, ReactNode, useContext
} from 'react';

import clsx from 'clsx';
import { useToggle } from 'usehooks-ts';

import EditOutlineIcon from '../assets/EditOutlineIcon';
import { SavaContext } from '../providers/SavaProvider';
import { CfSys } from '../types';
import { getEntryUrl } from '../utils/contentful';
import IconButton from './atoms/IconButton';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  sys: CfSys
  anchorId?: string
}

const CfDebugger = ({
  anchorId,
  children,
  className,
  sys,
  ...props
}: Props) => {
  const {
    cfSpaceId: spaceId, debugMode, isProd,
  } = useContext(SavaContext) ?? {};
  const [isVisible, toggleIsVisible] = useToggle();
  const showDebugger = !!(spaceId && !isProd && debugMode);

  if (!showDebugger) {
    return (
      <div
        className={className}
        id={anchorId}
        {...props}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={clsx('relative border-transparent border-2 hover:border-red', className)}
      onMouseEnter={toggleIsVisible}
      onMouseLeave={toggleIsVisible}
      {...props}
    >
      <IconButton
        className={clsx(
          'bg-yellow can-hover:hover:bg-yellow-500 absolute top-0 right-0 w-6 h-6 fill-black',
          !isVisible && 'hidden'
        )}
        href={getEntryUrl({
          entryId: sys.id,
          spaceId: spaceId,
        })}
        icon={<EditOutlineIcon />}
      />
      {children}
    </div>
  );
};

export default CfDebugger;
